import alt from "../alt";
import indexBy from "lodash/keyBy";
import extend from "lodash/extend";
import values from "lodash/values";
import CreditActions from "../actions/CreditActions";
import CreditUtil from "../utils/CreditUtil";
import PersonStore from "../stores/PersonStore";

class CreditStore {
  constructor() {
    this.bindActions(CreditActions);

    this.state = {
      isFetching: false,
      credits: null,
      events: []
    };

    this.exportPublicMethods({
      creditsAvailable: this.creditsAvailable.bind(this)
    });
  }

  creditsAvailable() {
    return this.state.credits;
  }

  onReset() {
    this.setState({
      credits: null,
      events: []
    });
  }

  onFetchCredits() {
    this.setState({ isFetching: true });
    CreditUtil.fetchCredits(PersonStore.getState().token)
      .then(data => {
        this.setState({
          isFetching: false,
          credits: data.credits,
          events: data.events
        });
      })
      .catch(CreditActions.fetchFailed);
  }

  onFetchFailed(e) {
    window.alert(`Fetching credits failed: ${e.message}`);
  }
}

export default alt.createStore(CreditStore, "CreditStore");



// WEBPACK FOOTER //
// ./src/app/stores/CreditStore.js